import { DEFAULT_LANGUAGE } from '@/i18n-setup';
import { HgSupportedLanguage } from '@smg-real-estate/domus';
import type { Router } from 'vue-router';

export const getLocaleFromRouter = (router: Router): HgSupportedLanguage => {
  const route = router.currentRoute.value;

  return ((route.params.locale ?? route.meta.locale) as HgSupportedLanguage) || DEFAULT_LANGUAGE;
};

export const getRouteFromRouter = (router: Router): string => router.currentRoute.value.path;
